import { Routes } from '@angular/router';

import { PROVISIONAL_FIQH_REVIEW_PACK } from '../domain/testing/be-country-pack.fixture';
import {
  BrowserReviewExportAdapter,
  IndexedDbReviewAnnotationsAdapter,
  ReviewContentAdapter,
} from '../infrastructure';
import { ReviewAnnotationsPort, ReviewContentPort, ReviewExportPort } from '../application';
import { baseRoutes } from './app.routes.base';

/*
 * The review screen comes first: the journey answers every other address, the ones it does not
 * know included, and would otherwise take this one too.
 */
export const routes: Routes = [
  {
    path: 'revue',
    providers: [
      {
        provide: ReviewContentPort,
        useFactory: () => new ReviewContentAdapter(PROVISIONAL_FIQH_REVIEW_PACK),
      },
      { provide: ReviewAnnotationsPort, useClass: IndexedDbReviewAnnotationsAdapter },
      { provide: ReviewExportPort, useClass: BrowserReviewExportAdapter },
    ],
    loadComponent: () =>
      import('../features/imam-review/imam-content-review.component').then(
        (module) => module.ImamContentReviewComponent,
      ),
  },
  ...baseRoutes,
];
